import { Button } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import Feature from "byzantine/src/Feature";

import { useUserFeatures } from "../contexts/UserFeaturesContext";
import SectionCard from "../SectionCard";

const StatementsCard = () => {
  const { l10n } = useLocalization();
  const features = useUserFeatures();

  return (
    <Feature features={features} flag="statements">
      <SectionCard>
        <SectionCard.Title
          text={l10n.getString("statements-card-title")}
          button={
            <Button
              kind="plain"
              onClick={() => window.location.assign("/statements")}
              label={l10n.getString("statements-card-button-label")}
              testId="statements-card"
            />
          }
        />
      </SectionCard>
    </Feature>
  );
};

export default StatementsCard;
